import ErrorDetails from 'common/error/components/error-details';
import ErrorHandler from 'common/error/components/error-handler';
import { Toolbar } from 'common/toolbar';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { DropdownButton, Flex, notification } from 'ui';
import { withRouter } from 'utils/withRouter';
import {
  multipleProcessQuickActions,
  notificationWorklistId,
  ticketWorklistId,
} from '../../../utils/app-configs';
import {
  orderActions,
  planningActions,
  ticketActions,
} from '../../../workgrid/helpers/grid-helpers';
import {
  getWarningDescription,
} from '../../gantt/components/block/components/block-detail-actions';
import WarningNotification from '../../publish-steps/WarningNotification';
import StartDateDialog from './start-date-dialog';
// eslint-disable-next-line max-len
import QuestionWarningNotification from '../../../tickets/components/list/question-warning-notification';
import { category, ticketActionIds } from '../../../tickets/ticket-config';
import { isObjectNullOrEmpty } from '../../../utils/helpers';
import { viewConfig } from '../../gantt/config';

class ToolbarDynamicActions extends Component {
  static propTypes = {
    availableActions: PropTypes.object,
    createDraftOrders: PropTypes.func.isRequired,
    createAutoOrders: PropTypes.func.isRequired,
    reload: PropTypes.func.isRequired,
    generalError: PropTypes.object,
    singleErrors: PropTypes.array,
    successCreateIds: PropTypes.array,
    autoCreateFailed: PropTypes.array,
    autoDraftFailed: PropTypes.array,
    errors: PropTypes.array,
    autoFaulty: PropTypes.number,
    autoTotal: PropTypes.number,
    intl: PropTypes.object,
    history: PropTypes.object,
    isCreating: PropTypes.bool,
    deleteOrders: PropTypes.func,
    deleteSuccess: PropTypes.bool,
    isPlanningBoard: PropTypes.bool,
    createSuccess: PropTypes.bool,
    isPlanningSelected: PropTypes.bool,
    autoPlanningAction: PropTypes.func,
    autoPlanningInfo: PropTypes.object,
    selectedRowAction: PropTypes.object,
    setSelectedRowAction: PropTypes.func,
    isFullScreen: PropTypes.bool,
    setIsFullScreen: PropTypes.func,
    updateFilters: PropTypes.func,
    worklistId: PropTypes.string,
    createAutoTickets: PropTypes.func,
    getCategoryInfo: PropTypes.func,
    questions: PropTypes.array,
    tags: PropTypes.array,
    planningBlocks: PropTypes.arrays,
    publishToSapQuickAction: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      startDateVisible: false,
      startDateSuccessFn: null,
      selectedActions: null,
      needsTime: false,
      needsWorkcenter: false,
      multipleProcess: null,
    };
  }

  componentDidMount() {
    if (this.props.worklistId === ticketWorklistId) {
      this.props.getCategoryInfo({ id: category.diagnostics });
    }
  }

  // eslint-disable-next-line complexity
  componentWillReceiveProps(nextProps) {
    // TODO: check if this is not an anti-pattern
    const {
      autoCreateFailed,
      autoDraftFailed,
      autoFaulty,
      autoTotal,
      reload,
      errors,
      intl,
      deleteSuccess,
      createSuccess,
      autoPlanningInfo = {},
      selectedRowAction = '',
      worklistId,
      planningBlocks,
      generalError,
    } = nextProps;
    const publishMoveToOrders = worklistId !== ticketWorklistId ?
      JSON.parse(localStorage.getItem('publishMoveToOrders')) :
      false;

    if (!isObjectNullOrEmpty(generalError) && this.state.multipleProcess && publishMoveToOrders) {
      this.setState({ multipleProcess: null });
    }
    if (
      selectedRowAction &&
      Object.keys(selectedRowAction)?.length &&
      selectedRowAction?.id !== this.props.selectedRowAction?.id
    ) {
      if (planningActions.includes(selectedRowAction?.id)) {
        this.handleAdminUser(
          [selectedRowAction.payload],
          selectedRowAction?.id !== 'updatePlanningBackground',
          selectedRowAction?.id === 'updatePlanningBackground',
          selectedRowAction?.id === 'updatePlanningBackground',
        );
      } else if (orderActions.includes(selectedRowAction?.id)) {
        const isPlanning = selectedRowAction?.id === 'planOrderTentativeBackground' ||
          selectedRowAction?.id === 'planOrderConfirmedBackground' ||
          selectedRowAction?.id === 'planOrderBackground';

        this.createAutoOrders(
          [selectedRowAction.payload],
          isPlanning,
          isPlanning,
          selectedRowAction?.id === 'cancelOrderAction',
          isPlanning && this.props.isPlanningBoard,
          selectedRowAction?.id === 'planOrderConfirmedBackground',
        );
      } else if (ticketActions.includes(selectedRowAction?.id)) {
        this.handleTicketAction([selectedRowAction.payload]);
      } else if (selectedRowAction?.id === 'deleteDraftAction') {
        this.props.deleteOrders({
          actions: [selectedRowAction.payload],
          worklistId,
          isDelete: true,
        });
      } else if (selectedRowAction?.id === 'createDraftOrder') {
        this.createDraftOrders([selectedRowAction.payload]);
      } else if (selectedRowAction?.id === 'editOrder') {
        this.editOrder([selectedRowAction.payload]);
      }
      this.props.setSelectedRowAction({});
    }

    if (
      Object.keys(autoPlanningInfo)?.length &&
      (!this.props.autoPlanningInfo || !Object.keys(this.props.autoPlanningInfo)?.length)
    ) {
      const { totalCount, failedCount, succeededCount } = autoPlanningInfo;
      if (succeededCount === totalCount) {
        this.setState({ multipleProcess: null });
        notification.success({
          message: this.props.intl.formatMessage({
            id: 'toolbar.AUTO_PLANNING_SUCCESS',
          }),
          placement: 'top',
        });
      } else {
        this.setState({ multipleProcess: null });
        notification.warning({
          message: this.props.intl.formatMessage(
            { id: 'toolbar.SOME_PLANNING_FAILED' },
            { failedCount, totalCount },
          ),
          placement: 'top',
          description: <WarningNotification
            onConfirm={() => {
              nextProps.updateFilters({ order: autoPlanningInfo.failedIds });
              notification.destroy('partiallyExecutedInfo');
            }}
            body={<p>{this.props.intl.formatMessage({
              id: 'toolbar.SOME_PLANNING_FAILED_MESSAGE',
            })}</p>}
            isLoading={false}
            confirmButtonText={this.props.intl.formatMessage({
              id: 'toolbar.SHOW_FAILED_PLANNING_WORKLIST',
            })}
          />,
          key: 'partiallyExecutedInfo',
          className: 'extended-notification',
          duration: 0,
        });
      }
      return;
    }

    // Flow for auto (background) orders
    // If the total amount is different, the call is finished.
    if (autoTotal > 0 && autoTotal !== this.props.autoTotal) {
      // if there are no faulty calls, show success message
      if ((autoFaulty === 0 && !deleteSuccess) || (planningBlocks?.length && publishMoveToOrders)) {
        if (autoFaulty === 0 && !deleteSuccess) {
          notification.success({
            message: this.props.intl.formatMessage({
              id: worklistId !== ticketWorklistId ?
                'toolbar.AUTO_SUCCESS' :
                'toolbar.TICKETS_AUTO_SUCCESS',
            }),
            placement: 'top',
          });
        }
        if (this.state.selectedActions?.includes('updateOrderBackground')) {
          if (planningBlocks?.length && publishMoveToOrders &&
            this.state.multipleProcess === multipleProcessQuickActions.processingOrders
          ) {
            this.changeMultipleProcess();
            this.props.publishToSapQuickAction({
              planningIds: planningBlocks?.map(pb => pb.id),
              boardId: viewConfig.boardIdTypes.service,
              isTimeline: !this.props.worklistId,
              publishWithQuickAction: true,
            });
          }
          if (
            !publishMoveToOrders ||
            (publishMoveToOrders &&
              this.state.multipleProcess === multipleProcessQuickActions.publishToSap)
          ) {
            this.setState({ multipleProcess: null });
            reload();
          }
        } else {
          reload();
        }
        return;
      } else if (autoFaulty === 0 && deleteSuccess) {
        // Reload the data
        reload();
        return;
      }

      // If drafts or create failed, show how a notification.
      if (
        (autoDraftFailed.length || autoCreateFailed.length) &&
        !(planningBlocks?.length && publishMoveToOrders)
      ) {
        this.setState({ multipleProcess: null });
        notification.error({
          message: <ErrorDetails
            errors={errors}
            autoFaulty={autoFaulty}
            autoTotal={autoTotal}
            // Antd does not support injectIntl inside a component
            // so we need to pass it from this component
            translate={intl.formatMessage}
          />,
          placement: 'top',
          key: 'autoFailed',
          duration: 0,
        });
        // If create failed, navigate to the orders. Tickets does not support multi open
        if (autoCreateFailed.length && worklistId !== ticketWorklistId) {
          nextProps.setIsFullScreen(false);
          this.props.history.push(
            `/order/${autoCreateFailed?.map(o => encodeURIComponent(o)).join(',')}`,
          );
        }
      }
    }

    // Flow for draft orders
    if (
      nextProps.successCreateIds &&
      nextProps.successCreateIds.length &&
      nextProps.successCreateIds !== this.props.successCreateIds
    ) {
      // if there was a successfull draft order,
      // redirect to the order details
      notification.success({
        message: this.props.intl.formatMessage({
          id: 'toolbar.CREATE_ORDERS_SUCCESS',
        }),
        placement: 'top',
      });
      nextProps.setIsFullScreen(false);
      nextProps.history.push(
        `/order/${nextProps.successCreateIds?.map(o =>
          encodeURIComponent(o),
        ).join(',')}`,
      );
    }

    if (createSuccess) {
      if (this.state.startDateVisible) {
        this.setState({
          startDateVisible: false,
          startDateSuccessFn: null,
          selectedActions: null,
          needsTime: false,
          needsWorkcenter: false,
        });
      }
    }
  }

  getPlanActions = () => {
    const { availableActions, intl, isPlanningBoard } = this.props;
    let actions = [];

    if (!isPlanningBoard) {
      actions = [...actions, {
        text: intl.formatMessage({
          id: 'toolbar.CREATE_BACKGROUND_PLANTENTATIVE',
        }),
        onClick:
          () => this.createAutoOrders(
            availableActions.planOrderTentativeBackground,
            true,
            true,
            false,
            isPlanningBoard,
          ),
        disabled: !Object.keys(availableActions).includes('planOrderTentativeBackground'),
      },
      {
        text: intl.formatMessage({
          id: 'toolbar.CREATE_BACKGROUND_PLANCONFIRMED',
        }),
        onClick:
          () => this.createAutoOrders(
            availableActions.planOrderConfirmedBackground,
            true,
            true,
            false,
            isPlanningBoard,
            true,
          ),
        disabled: !Object.keys(availableActions).includes('planOrderConfirmedBackground'),
      }];
    }

    // This should be also showed on timeline, worklistId will be here undefined then
    // So check on when not to show
    if (
      this.props.worklistId !== notificationWorklistId &&
      this.props.worklistId !== ticketWorklistId &&
      this.props.worklistId !== 'call'
    ) {
      actions = [...actions, {
        text: intl.formatMessage({
          id: 'toolbar.UPDATE_ORDER_BACKGROUND',
        }),
        onClick:
          () => this.createAutoOrders(
            availableActions.updateOrderBackground,
            true,
            true,
            false,
            isPlanningBoard,
            true,
          ),
        disabled: !Object.keys(availableActions).includes('updateOrderBackground'),
      }];
    }

    return actions;
  };

  // provide service center id to the quick action
  getServiceCenterId = () => {
    const { availableActions } = this.props;
    if (availableActions?.planOrderTentativeBackground?.length) {
      return availableActions.planOrderTentativeBackground[0].serviceCenterId;
    } else if (availableActions?.planOrderConfirmedBackground?.length) {
      return availableActions.planOrderConfirmedBackground[0].serviceCenterId;
    } else if (availableActions?.updatePlanningBackground?.length) {
      return availableActions.updatePlanningBackground[0].serviceCenterId;
    } else if (availableActions?.deleteUnpublishedPlanningBackground?.length) {
      return availableActions.deleteUnpublishedPlanningBackground[0].serviceCenterId;
    } else if (availableActions?.updateOrderBackground?.length) {
      return availableActions.updateOrderBackground[0].serviceCenterId;
    }
    return null;
  };

  getQuestionNotification = onConfirm => <QuestionWarningNotification
    intl={this.props.intl}
    onConfirm={onConfirm}
    questionData={this.props.questions}
    tags={this.props.tags}
  />;

  changeMultipleProcess = () => {
    if (this.state.selectedActions?.includes('updateOrderBackground')) {
      if (!this.state.multipleProcess) {
        this.setState({ multipleProcess: multipleProcessQuickActions.processingOrders });
      }
      if (this.state.multipleProcess === multipleProcessQuickActions.processingOrders) {
        this.setState({ multipleProcess: multipleProcessQuickActions.publishToSap });
      }
    }
  };

  cancelStartDateDialog = () => {
    this.setState({ multipleProcess: null });
    notification.info({
      message: this.props.intl.formatMessage({
        id: 'toolbar.NO_ORDERS_PROCESSED',
      }),
      placement: 'top',
    });
    this.setState({
      startDateVisible: false,
      startDateSuccessFn: null,
    });
  };

  createAutoOrders = (
    actions,
    needsTime = false,
    needsWorkcenter = false,
    skipDialog = false,
    shouldUpdatePlanningboard = false,
    keepOpen = false,
  ) => {
    // Always show the startdate modal.
    const { createAutoOrders, worklistId } = this.props;
    if (!skipDialog) {
      this.setState({
        selectedActions: actions?.map(i => i.action),
        needsTime,
        needsWorkcenter,
        startDateVisible: true,
        startDateSuccessFn: (newDate, workcenterId, isSequential, toStatus, sendToSap) => {
          // one item will always be send as sequentially: false if not this will give 500
          const hasSequentialOrder = actions?.length > 1 ? isSequential : false;
          createAutoOrders({
            actions,
            newDate,
            workcenterId,
            shouldUpdatePlanningboard,
            hasSequentialOrder: isSequential !== null && hasSequentialOrder,
            worklistId,
            toStatus,
            sendToSap,
          });
          if (!keepOpen) {
            this.setState({
              startDateVisible: false,
              startDateSuccessFn: null,
              selectedActions: null,
              needsTime: false,
              needsWorkcenter: false,
            });
          }
        },
      });
    } else {
      createAutoOrders({
        actions,
        shouldUpdatePlanningboard,
        worklistId,
      });
    }
  };

  handleQuestionResponse = (actions, v) => {
    const actionsData = actions.map((a) => {
      if (a.isDiagnosticsTicket && a.action === ticketActionIds.closeTicket) {
        return {
          ...a,
          tags: v,
        };
      }
      return a;
    });
    this.props.createAutoTickets({ actions: actionsData });
  };

  handleTicketAction = (actions) => {
    const questionTicket = actions.find(a =>
      a.action === ticketActionIds.closeTicket &&
      a.isDiagnosticsTicket,
    );
    if (questionTicket) {
      if (questionTicket.hasRequestedSmartAction) {
        notification?.error({
          message: this.props.intl.formatMessage({ id: 'common.ERROR_OCCURED' }),
          description: <>
            <p>{this.props.intl.formatMessage({ id: 'tickets.error.saveError' })}</p>
            <ul>
              <li>{this.props.intl.formatMessage(
                { id: 'tickets.error.cannotMoveBeyondStatusInProgress' },
              )}</li>
            </ul>
          </>,
          duration: 0,
          className: 'extended-notification',
        });
        this.setState({ multipleProcess: null });
      } else {
        notification.warning({
          message: this.props.intl.formatMessage({ id: 'ticket.QUESTION_WARNING_TITLE' }),
          description: this.getQuestionNotification(
            v => this.handleQuestionResponse(actions, v),
          ),
          placement: 'top',
          key: 'openQuestionsWarning',
          style: {
            width: 676,
            marginLeft: -100,
          },
          className: 'extended-notification',
          duration: 0,
        });
      }
    } else {
      this.props.createAutoTickets({ actions });
    }
  };

  handleAdminUser = (actions, skipModel, needsTime, shouldUpdatePlanningboard) => {
    const {
      intl,
    } = this.props;

    const isNotAssignedPlanningItems =
      actions?.filter(action => !action?.isAssignedPlanner);
    const isUserAdminPlanningItems =
      actions?.filter(action => action?.isUserAdminForScope);

    if (!isNotAssignedPlanningItems?.length) {
      this.autoPlanningAction(actions, skipModel, needsTime, shouldUpdatePlanningboard);
    } else if (isUserAdminPlanningItems) {
      notification.warning({
        message: intl.formatMessage({ id: 'planningBoard.blocks.ADMIN_WARNING_TITLE' }),
        placement: 'top',
        description: getWarningDescription(() => {
          notification.destroy('assignedPlannerWarning');
          this.autoPlanningAction(actions, skipModel, needsTime, shouldUpdatePlanningboard);
        }, intl),
        className: 'extended-notification',
        key: 'assignedPlannerWarning',
        duration: 0,
      });
    }
  };

  autoPlanningAction = (
    actions,
    skipModel = true,
    needsTime = false,
    shouldUpdatePlanningboard = false,
    toStatus,
  ) => {
    const { autoPlanningAction, worklistId } = this.props;
    if (skipModel) {
      autoPlanningAction({
        actions,
        boardId: 'service',
        worklistId,
        shouldUpdatePlanningboard,
      });
    } else {
      this.setState({
        selectedActions: actions?.map(i => i.action),
        needsTime,
        startDateVisible: true,
        startDateSuccessFn: (newDate, workcenterId, isSequential) => {
          // one planning item will always be send as sequentially: false if not this will give 500
          const hasSequentialOrder = actions?.length > 1 ? isSequential : false;
          autoPlanningAction({
            actions,
            boardId: 'service',
            newDate,
            workcenterId,
            shouldUpdatePlanningboard,
            hasSequentialOrder,
            worklistId,
            toStatus,
          });
          this.setState({
            startDateVisible: false,
            startDateSuccessFn: null,
          });
        },
      });
    }
  };

  createDraftOrders = (actions) => {
    // Always show the startdate modal.
    const { createDraftOrders } = this.props;
    this.setState({
      startDateVisible: true,
      startDateSuccessFn: (newDate) => {
        createDraftOrders({ actions, newDate });
        this.setState({
          startDateVisible: false,
          startDateSuccessFn: null,
        });
      },
    });
  };

  editOrder = (payload) => {
    // navigate to the orders
    const { history, setIsFullScreen } = this.props;
    setIsFullScreen(false);
    // Don't show the startdate modal.
    const idArray = payload?.map(p => encodeURIComponent(p.id));
    history.push(`/order/${idArray.join(',')}`);
  };

  determineActionButtons = () => {
    const {
      availableActions,
      isCreating,
      intl,
      isPlanningSelected = false,
      worklistId,
    } = this.props;
    const {
      selectedActions,
      startDateVisible,
      startDateSuccessFn,
      needsTime,
      needsWorkcenter,
    } = this.state;
    const planActions = this.getPlanActions();

    const getActions = () => {
      if (worklistId === ticketWorklistId) {
        return [
          {
            text: intl.formatMessage({
              id: 'toolbar.CLOSE_TICKET',
            }),
            onClick: () =>
              this.handleTicketAction(availableActions.closeTicket),
            disabled: !Object.keys(availableActions).includes(ticketActionIds.closeTicket),
          },
        ];
      }
      if (isPlanningSelected) {
        return [
          {
            text: intl.formatMessage({
              id: 'toolbar.CONFIRM_PLANNING_BACKGROUND',
            }),
            onClick: () =>
              this.handleAdminUser(availableActions.confirmPlanningBackground, true, false, true),
            disabled: !Object.keys(availableActions).includes('confirmPlanningBackground'),
          },
          {
            text: intl.formatMessage({
              id: 'toolbar.UNCONFIRM_PLANNING_BACKGROUND',
            }),
            onClick: () =>
              this.handleAdminUser(availableActions.unConfirmPlanningBackground, true, false, true),
            disabled: !Object.keys(availableActions).includes('unConfirmPlanningBackground'),
          },
          {
            text: intl.formatMessage({
              id: 'toolbar.PUBLISH_PLANNING_BACKGROUND',
            }),
            onClick: () =>
              this.handleAdminUser(availableActions.publishPlanningBackground, true, false, true),
            disabled: !Object.keys(availableActions).includes('publishPlanningBackground'),
          },
          {
            text: intl.formatMessage({
              id: 'toolbar.REVERT_PLANNING_BACKGROUND',
            }),
            onClick: () =>
              this.handleAdminUser(availableActions.revertPlanningBackground, true, false, true),
            disabled: !Object.keys(availableActions).includes('revertPlanningBackground'),
          },
          {
            text: intl.formatMessage({
              id: 'toolbar.UPDATE_PLANNING_BACKGROUND',
            }),
            onClick: () =>
              this.handleAdminUser(availableActions.updatePlanningBackground,
                false, true, true),
            disabled: !Object.keys(availableActions).includes('updatePlanningBackground'),
          },
          {
            text: intl.formatMessage({
              id: 'toolbar.DELETE_UNPUBLISHED_PLANNING_BACKGROUND',
            }),
            onClick: () =>
              this.handleAdminUser(
                availableActions.deleteUnpublishedPlanningBackground,
                true,
                false,
                true,
              ),
            disabled: !Object.keys(availableActions).includes(
              'deleteUnpublishedPlanningBackground',
            ),
          },
        ];
      }
      return [
        {
          text: intl.formatMessage({
            id: 'toolbar.CREATE_AND_SHOW_DRAFT',
          }),
          onClick: () => this.createDraftOrders(availableActions.createDraftOrder),
          disabled: !Object.keys(availableActions).includes('createDraftOrder'),
        },
        {
          text: intl.formatMessage({
            id: 'toolbar.CREATE_AND_SHOW_EDIT',
          }),
          onClick: () => this.editOrder(availableActions.editOrder),
          disabled: !Object.keys(availableActions).includes('editOrder'),
        },
        {
          text: intl.formatMessage({
            id: 'toolbar.CREATE_BACKGROUND_DRAFT',
          }),
          onClick: () => this.createAutoOrders(availableActions.draftOrderBackground),
          disabled: !Object.keys(availableActions).includes('draftOrderBackground'),
        },
        {
          text: intl.formatMessage({
            id: 'toolbar.CREATE_BACKGROUND_CREATE',
          }),
          onClick: () => this.createAutoOrders(availableActions.createOrderBackground),
          disabled: !Object.keys(availableActions).includes('createOrderBackground'),
        },
        {
          text: intl.formatMessage({
            id: 'toolbar.CREATE_BACKGROUND_RELEASE',
          }),
          onClick: () => this.createAutoOrders(availableActions.releaseOrderBackground),
          disabled: !Object.keys(availableActions).includes('releaseOrderBackground'),
        },
        ...planActions,
        {
          text: intl.formatMessage({
            id: 'toolbar.CANCEL_ORDER_BACKGROUND',
          }),
          onClick: () => this.createAutoOrders(
            availableActions.cancelOrderAction,
            false,
            false,
            true,
          ),
          disabled: !Object.keys(availableActions).includes('cancelOrderAction'),
        },
        {
          text: intl.formatMessage({
            id: 'toolbar.DELETE_DRAFT_ACTION',
          }),
          onClick:
            () => this.props.deleteOrders({
              actions: availableActions.deleteDraftAction,
              worklistId: this.props.worklistId,
              isDelete: true,
            }),
          disabled: !Object.keys(availableActions).includes('deleteDraftAction'),
        },
      ];
    };

    return (
      <Flex>
        <Toolbar.Item key='quickActions' showAsQuickAccess={true}>
          <DropdownButton
            colortheme='theme'
            primary={1}
            isLoading={isCreating}
            text={intl.formatMessage({
              id: 'toolbar.QUICK_ACTIONS',
            })}
            uppercase={true}
            asSeperate={false}
            disabled={!Object.keys(availableActions).length}
            subItems={getActions()}
          />
        </Toolbar.Item>
        <StartDateDialog
          changeMultipleProcess={this.changeMultipleProcess}
          multipleProcess={this.state.multipleProcess}
          selectedActions={selectedActions}
          visible={startDateVisible}
          onSubmit={startDateSuccessFn}
          onClose={this.cancelStartDateDialog}
          needsTime={needsTime}
          needsWorkcenter={needsWorkcenter}
          serviceCenterId={this.getServiceCenterId()}
          loading={isCreating}
          isFullScreen={this.props.isFullScreen}
          allowPast={this.props.isPlanningSelected}
        />
      </Flex>
    );
  };

  render() {
    const { generalError, singleErrors, isPlanningBoard = false } = this.props;
    return (
      <Flex>
        {singleErrors?.map((e, i) =>
          <ErrorHandler
            key={i}
            type='notification'
            error={e}
            isFullScreen={isPlanningBoard}
          />,
        )}
        <ErrorHandler
          type='notification'
          error={generalError}
          isFullScreen={isPlanningBoard}
        />
        {this.determineActionButtons()}
      </Flex>
    );
  }
}

export default withRouter(injectIntl(ToolbarDynamicActions));
